import BuildingMaterialComponent from './BuildingMaterialComponent';

export default BuildingMaterialComponent;